import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyTracker from 'shared/ahoy_tracker';

export default class LivestreamingRelated {
  constructor(options) {
    this.$container = options.$element;
    this.container = options.element;
  }

  init() {
    this.loadData();
  }

  loadData() {
    var schedule_id = this.container.dataset.scheduleId;
    var url = `/live/related/${ schedule_id }.html`;
    $.get(url)
      .done(data => { this.modifyElement(data); })
      .fail(e => {console.error(e);});
  }

  modifyElement(element) {
    try {
      var el = $.parseHTML(element)[0];
      var $element = $(el);

      if(this.hasContent($element)) {
        this.$container.after($element);
        this.initJsAhoy();
      }

      this.$container.remove();
    } catch(e) {
      console.error('CatchedLivestreamingRelated', e);
    }
  }

  hasContent($element) {
    if (VidioHelpers.isMobile()) {
      return $element.find('.b-section__item').length > 0;
    }
    return $element.find('.livestreaming-events__item').length > 0;
  }

  initJsAhoy() {
    let elements = this.$container.find('.js-ahoy');

    for(var i = 0; i < elements.length; i++) {
      let element = elements[i];
      if(element.dataset.ahoyloaded !== 'true'){

        var ahoy_tracker = new AhoyTracker(element);
        ahoy_tracker.init();

        element.dataset.ahoyloaded = 'true';
      }
    }
  }
}
